import React from "react";

import { pathname as newslettersPathname } from "~/pages/newsletters";

import Email from "./icon-email.svg";
import { Button, Container, Title } from "./styles";

export type Props = {
  className?: string;
  onClick: (destination: string) => void;
};

export const HomeFooterNewsletter: React.FunctionComponent<Props> = ({ className, onClick }) => (
  <Container className={className}>
    <Title>Sign up for our newsletters</Title>
    <Button pathname={newslettersPathname} onClick={() => onClick(newslettersPathname)}>
      <Email />
      <span>FIND OUT MORE</span>
    </Button>
  </Container>
);

HomeFooterNewsletter.displayName = "HomeFooterNewsletter";
